import { appendSearchParamsIfSet } from './appendSearchParamsIfSet'

export const getAuthorizationRequestUrl = (clientId: string, state: string | undefined | null, authBaseUrl: string) => {
  const authCode = crypto.randomUUID?.() ?? crypto.getRandomValues(new Uint32Array(40)).join('')

  return {
    authCode,
    authUrl: appendSearchParamsIfSet(`${authBaseUrl}/authorize`, {
      clientId,
      authCode,
      state,
      scope: state ? 'state' : null,
    }),
  }
}
